// Skeleton loader — Night Signal aesthetic, Graphite #2A2A2A pulse
export function SkeletonBar({ w = "100%", h = "1rem", className = "" }) {
    return (
        <div
            className={`bg-[#2A2A2A] animate-pulse-signal ${className}`}
            style={{ width: w, height: h }}
            data-testid="skeleton-bar"
        />
    );
}

export function SkeletonBlock({ className = "", children }) {
    return (
        <div className={`border border-[#2A2A2A] bg-jet-elev1 p-5 ${className}`} data-testid="skeleton-block">
            {children}
        </div>
    );
}

export function DashboardSkeleton() {
    return (
        <div className="space-y-6" data-testid="dashboard-skeleton">
            <div className="flex items-end justify-between">
                <div className="space-y-2">
                    <SkeletonBar w="120px" h="0.6rem" />
                    <SkeletonBar w="320px" h="2.5rem" />
                </div>
                <SkeletonBar w="180px" h="2.25rem" />
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {[0, 1, 2, 3].map((i) => (
                    <SkeletonBlock key={i}>
                        <SkeletonBar w="60%" h="0.6rem" />
                        <SkeletonBar w="40%" h="2rem" className="mt-3" />
                    </SkeletonBlock>
                ))}
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {[0, 1].map((i) => (
                    <SkeletonBlock key={i}>
                        <SkeletonBar w="40%" h="0.6rem" />
                        <div className="space-y-3 mt-4">
                            {[0, 1, 2, 3].map((j) => (
                                <SkeletonBar key={j} w="100%" h="0.5rem" />
                            ))}
                        </div>
                    </SkeletonBlock>
                ))}
            </div>
            <SkeletonBlock>
                <SkeletonBar w="40%" h="0.6rem" />
                <div className="space-y-2 mt-4">
                    {[0, 1, 2, 3, 4].map((j) => (
                        <SkeletonBar key={j} w="100%" h="2rem" />
                    ))}
                </div>
            </SkeletonBlock>
        </div>
    );
}

export function ProductDetailSkeleton() {
    return (
        <div className="space-y-6" data-testid="product-detail-skeleton">
            <SkeletonBar w="180px" h="0.6rem" />
            <SkeletonBlock>
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
                    <div className="flex-1 space-y-3">
                        <SkeletonBar w="120px" h="0.6rem" />
                        <SkeletonBar w="60%" h="2.5rem" />
                        <div className="flex gap-2">
                            <SkeletonBar w="100px" h="1.25rem" />
                            <SkeletonBar w="80px" h="1.25rem" />
                            <SkeletonBar w="120px" h="1.25rem" />
                        </div>
                    </div>
                    <div className="flex gap-4">
                        <SkeletonBlock className="min-w-[200px]">
                            <SkeletonBar w="60%" h="0.6rem" />
                            <SkeletonBar w="80%" h="3rem" className="mt-3" />
                            <SkeletonBar w="100%" h="0.5rem" className="mt-2" />
                        </SkeletonBlock>
                        <SkeletonBar w="180px" h="4rem" />
                    </div>
                </div>
            </SkeletonBlock>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
                <SkeletonBlock className="lg:col-span-5 min-h-[400px]">
                    <SkeletonBar w="50%" h="0.6rem" />
                    <div className="space-y-3 mt-4">
                        {[0, 1, 2, 3, 4, 5, 6].map((j) => (
                            <div key={j} className="flex items-center gap-3">
                                <SkeletonBar w="2rem" h="2rem" />
                                <SkeletonBar w="100%" h="2.5rem" />
                            </div>
                        ))}
                    </div>
                </SkeletonBlock>
                <SkeletonBlock className="lg:col-span-7 min-h-[400px]">
                    <SkeletonBar w="40%" h="0.6rem" />
                    <SkeletonBar w="100%" h="6rem" className="mt-4" />
                    <SkeletonBar w="50%" h="0.6rem" className="mt-4" />
                    <div className="flex gap-2 mt-2">
                        {[0, 1, 2].map((j) => (
                            <SkeletonBar key={j} w="80px" h="1.25rem" />
                        ))}
                    </div>
                </SkeletonBlock>
            </div>
        </div>
    );
}
